import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=dd66f06c"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports